import { VideoDirective } from "../video/video.directive";
import {
	Component,
	OnInit,
	OnChanges,
	Input,
	Output,
	ElementRef,
	EventEmitter,
	ViewChild,
	ChangeDetectorRef,
} from "@angular/core";
import { AppServices } from "app/app.services";
import { ApplicationModel } from "app/core/models/application.model";
import { OrientationService } from "app/services/orientation.service";
import { UtilityScripts } from "app/helpers/utility-scripts";
import { CourseContextModelService } from "app/core/models/course-context-model.service";
import { AppConstants, KeyPressConstants } from "app/core/vo/app-constants";

@Component({
	selector: "app-video-custom-controls",
	templateUrl: "./video_custom_controls.html",
	styleUrls: ["./video_custom_controls.css"],
})
export class VideoWithCustomControlsDirective implements OnChanges {
	@Input() video_url: string;
	@Input() video_width?: string;
	@Input() video_height?: string;
	@Input() autoplay?: boolean;
	@Input() controls?: boolean;
	@Input() loop?: boolean;
	@Input() pauseVideo: boolean;
	@Input() video_style?: string;
	@Input() enabledScrub: boolean;
	@Input() playbackRate?: number = 1;
	@ViewChild("autoVideoPlayBtn") autoVideoPlayBtn;
	@Output() startHandler?: EventEmitter<any> = new EventEmitter<any>();
	@Output() completehandler?: EventEmitter<any> = new EventEmitter<any>();
	@Output() pausehandler?: EventEmitter<any> = new EventEmitter<any>();
	@Output() updateTime?: EventEmitter<any> = new EventEmitter<any>();

	@ViewChild("videocontainer", { static: true }) videocontainer: ElementRef;
	@ViewChild("videoElement") set video(content: ElementRef) {
		if (content) {
			this.video_el = content.nativeElement;
		}
	}
	@ViewChild("playpause", { static: true }) playpause: ElementRef;
	// @ViewChild('fullscreen') fullscreen: ElementRef;
	@ViewChild("mute") mute: ElementRef;
	@ViewChild("progress", { static: true }) progressBar: ElementRef;
	@ViewChild("progressBar", { static: true }) parentBar: ElementRef;
	@ViewChild("drag", { static: true }) drag: ElementRef;

	protected videocontainer_el: any;
	protected video_el: any;
	protected playpause_el: any;
	//protected fullscreen_el: any;
	protected mute_el: any;
	protected drag_el: any;
	protected parentBar_el: any;
	protected progressBar_el: any;
	public bPlaying: boolean;
	public bAudioMute: boolean;
	public strTime: string;
	public bFullScreen: boolean;
	public device: string;
	private isPause: boolean;
	private isPlayBeforeDrag: boolean = true;
	public iOSDevice: Boolean = false;
	public speedVariables: any[];
	public showSpeedOptions: boolean = false;
	public showSpeedDropDown: boolean = false;
	constructor(
		private appServices: AppServices,
		private cdr: ChangeDetectorRef,
		public orientaion: OrientationService,
		private courseContextModel: CourseContextModelService
	) {
		if (/iPhone|ipad/i.test(navigator.userAgent)) {
			ApplicationModel.instance.videoOverlay = true;
		}
	}
	ngOnInit() {
		this.iOSDevice = navigator.platform.indexOf("MacIntel") != -1;
		if (
			/iPhone|ipad/i.test(navigator.userAgent) ||
			(this.iOSDevice && window.innerWidth <= 1024)
		) {
			this.device = "ios";
		} else {
			this.device = "";
		}
	}
	private configPlayerSpeed() {
		this.showSpeedOptions =
			this.courseContextModel.currentLanguage == AppConstants.US_ENGLISH
				? false
				: true;
		if (this.showSpeedOptions) {
			if (ApplicationModel.instance.playerSpeed) {
				this.video_el.playbackRate = ApplicationModel.instance.playerSpeed;
			}
		} else {
			this.video_el.playbackRate = 1;
		}
	}
	ngOnChanges(changes) {
		if (
			changes.hasOwnProperty(`pauseVideo`) &&
			changes[`pauseVideo`][`currentValue`] !== undefined
		) {
			if (changes[`pauseVideo`][`currentValue`] === false && this.isPause) {
				this.pauseVideo = true;
			}
		}
	}
	ngAfterViewInit() {
		this.bPlaying = false;
		this.bAudioMute = false;
		this.bFullScreen = false;
		this.strTime = "00:00 / 00:00";
		this.videocontainer_el = this.videocontainer.nativeElement;
		this.playpause_el = this.playpause.nativeElement;
		// this.fullscreen_el = this.fullscreen.nativeElement;
		this.mute_el = this.mute ? this.mute.nativeElement : null;
		this.progressBar_el = this.progressBar.nativeElement;
		this.parentBar_el = this.parentBar.nativeElement;
		this.video_el.muted = ApplicationModel.instance.muteAudioVideo;
		this.bAudioMute = ApplicationModel.instance.muteAudioVideo;
		this.drag_el = this.drag.nativeElement;
		if (this.drag_el) {
			this.drag_el.addEventListener(
				"mousedown",
				this.onScrubHandleClick.bind(this),
				false
			);
			this.drag_el.addEventListener(
				"touchstart",
				this.onScrubHandleClick.bind(this),
				false
			);
			this.drag_el.addEventListener(
				"keydown",
				this.sliderProgressKeyboard.bind(this),
				false
			  );
		}
		this.video_el.controls = false;
		if (this.video_el) {
			this.video_el.removeAttribute("controls");
			this.video_el.addEventListener(
				"play",
				() => {
					this.bPlaying = true;
				},
				false
			);
			this.video_el.addEventListener(
				"pause",
				() => {
					this.bPlaying = false;
				},
				false
			);
			this.video_el.addEventListener(
				"timeupdate",
				() => {
					var value = 0;
					if (
						this.video_el &&
						this.video_el.currentTime >= 0 &&
						this.video_el.duration > 0
					) {
						this.strTime =
						this.timeFormat(this.video_el.currentTime) +
							" / " +
							this.timeFormat(this.video_el.duration);
						value = Math.ceil(
							(100 / this.video_el.duration) * this.video_el.currentTime
						);
						if (value > 100) {
							value = 100;
						}
					}
					if (this.progressBar_el) {
						this.progressBar_el.style.width = value + "%";
						this.progressBar_el.ariaValueNow = Math.floor(
							this.video_el.currentTime
						);
						this.progressBar_el.ariaValueMax = Math.floor(
							this.video_el.duration
						);
						this.progressBar_el.ariaValueText =
							this.timeFormatAriaText(this.video_el.currentTime) +
							" of " +
							this.timeFormatAriaText(this.video_el.duration);
					}
					if (this.drag_el) {
						this.drag_el.style.left = `${value}%`;
						this.drag_el.ariaValueNow = Math.floor(this.video_el.currentTime);
            			this.drag_el.ariaValueMax = Math.floor(this.video_el.duration);
            			this.drag_el.ariaValueText =
              				this.timeFormatAriaText(this.video_el.currentTime) +
              				" of " +
             				this.timeFormatAriaText(this.video_el.duration);
					}
					if (this.video_el.ended) {
						this.bPlaying = false;
					}
					this.updateTime.emit(this.video_el.currentTime);
				},
				false
			);
			this.configPlayerSpeed();
		}
	}
	public VideoEnded() {
		this.bPlaying = false;
		this.completehandler.emit({
			url: this.video_el.currentSrc,
			status: "complete",
		});
	}
	public videoStartHandler(event) {
		if (event) {
			this.startHandler.emit({ url: event.url, status: "start" });
		}
		this.playVideoBtnClickHandler();
		this.orientaion.end();
	}
	public videoPauseHandler(event) {
		if (event) {
			this.startHandler.emit({ url: event.url, status: "pause" });
		}
	}

	public togglePlayPause() {
		if (this.video_el.paused || this.video_el.ended) {
			this.bPlaying = true;
			ApplicationModel.instance.videoOverlay = false;
			this.video_el.play().then(() => {console.log('playing audio')}).catch((e) => {console.log('error in playing audio', e)});
			this.isPause = false;
			this.startHandler.emit({ status: "start" });
		} else {
			this.bPlaying = false;
			this.isPause = true;
			this.video_el.pause();
		}
	}
	public progressBarClickHandler(event) {
		if (this.enabledScrub) {
			let progressBarCoOrds: any = event.currentTarget.getBoundingClientRect();
			let left = event.pageX - progressBarCoOrds.left;
			let totalWidth = progressBarCoOrds.width;
			let percentage = left / totalWidth;
			let vidTime = this.video_el.duration * percentage;
			if (this.video_el.paused || this.video_el.ended) {
				this.video_el.pause();
				this.bPlaying = false;
			}
			this.video_el.currentTime = vidTime;
		}
	}

	public onScrubHandleClick(e) {
		if (this.enabledScrub) {
			if (e.cancelable) {
				e.preventDefault();
			}
			this.isPlayBeforeDrag = this.bPlaying;
			let progressBarCoOrds: any = this.parentBar_el.getBoundingClientRect();
			let totalWidth = progressBarCoOrds.width;
			const closeElementDrag = () => {
				document.onmouseup = document.ontouchend = null;
				document.onmousemove = document.ontouchmove = null;
				if (this.isPlayBeforeDrag) {
					this.video_el.play().then(() => {console.log('playing audio')}).catch((e) => {console.log('error in playing audio', e)});
					this.bPlaying = true;
				} else {
					this.video_el.pause();
					this.bPlaying = false;
				}
			};
			document.onmouseup = closeElementDrag;
			document.ontouchend = closeElementDrag;
			const elementDrag = (evnt) => {
				evnt.preventDefault();
				let clientX =
					evnt.type === "touchmove" ? evnt.touches[0].clientX : evnt.clientX;
				let left = clientX - progressBarCoOrds.left;
				left = left < 0 ? 0 : left > totalWidth ? totalWidth : left;
				let percentage = left / totalWidth;
				let vidTime = this.video_el.duration * percentage;
				this.video_el.currentTime = vidTime;
				this.video_el.pause();
			};
			document.onmousemove = elementDrag;
			document.ontouchmove = elementDrag;
		}
	}

	public sliderProgressKeyboard() {
		const removeKeyEvent = () => {
			document.onkeydown = null;
		};
		const elementKeyboardDrag = (e) => {
			if (
				e.keyCode === 37 &&
				this.video_el.currentTime > 0 &&
				this.enabledScrub
		 	) {
				let vidTime = this.video_el.currentTime - 10;
				this.video_el.currentTime = vidTime;
		  	}
		  	if (
				e.keyCode === 39 &&
				this.video_el.currentTime < this.video_el.duration &&
				this.enabledScrub
		  	) {
				let vidTime = this.video_el.currentTime + 10;
				this.video_el.currentTime = vidTime;
		 	}
		  	document.onkeydown = removeKeyEvent;
		};
		document.onkeydown = elementKeyboardDrag;
	}

	public toggleFullScreen() {
		this.bFullScreen = !this.bFullScreen;
		this.video_el.controls = false;
	}
	public toggleMute() {
		this.video_el.muted = !this.video_el.muted;
		this.bAudioMute = !this.bAudioMute;
		ApplicationModel.instance.muteAudioVideo = this.video_el.muted;
	}
	protected timeFormat(seconds) {
		var m: any =
			Math.floor(seconds / 60) < 10
				? "0" + Math.floor(seconds / 60)
				: Math.floor(seconds / 60);
		var s: any =
			Math.floor(seconds - m * 60) < 10
				? "0" + Math.floor(seconds - m * 60)
				: Math.floor(seconds - m * 60);
		return m + ":" + s;
	}
	protected timeFormatAriaText(seconds) {
		if (seconds) {
			var m: any = Math.floor(seconds / 60);
		 	var s: any = Math.floor(seconds - m * 60);
		 	return m + " Minutes " + s + " Seconds";
		} else {
			return "0 Minutes 0 Seconds";
		}
	}

	private showVideoPlayButton() {
		return ApplicationModel.instance.videoOverlay;
	}

	public onKeyDownClick(event) {
		if (event.code == KeyPressConstants.TAB) {
			event.preventDefault();
		}
	}							
	
	public playVideoBtnClickHandler() {
		if (this.autoVideoPlayBtn) {
			this.autoVideoPlayBtn.nativeElement.style.display = "none";
		}
		ApplicationModel.instance.videoOverlay = false;
		this.video_el.play().then(() => {console.log('playing audio')}).catch((e) => {console.log('error in playing audio', e)});
		this.startHandler.emit({ status: "start" });
	}
}
